import { Tab } from '@ui/components/Tabs';

export type GamesFilter = 'all' | 'live' | 'finished';

export const GAMES_FILTER_TABS: Tab<GamesFilter>[] = [
  { value: 'all', label: 'Все' },
  { value: 'live', label: 'Активные' },
  { value: 'finished', label: 'Завершенные' },
];
